import { InvoiceStatus } from "@wingspanhq/wingspan-api-sdk";

/**
 * Raw v3 `InvoiceStatus` groupings used to filter the dashboard tabs/summaries
 * server-side (`status.anyOf`). The tabs are a product concept (which lifecycle
 * statuses each shows); the values are the SDK's raw lifecycle statuses — there
 * is no FE-derived per-row status.
 */
export const INVOICE_STATUSES_DRAFT: InvoiceStatus[] = [InvoiceStatus.CREATED];

export const INVOICE_STATUSES_ACTION_REQUIRED: InvoiceStatus[] = [
  InvoiceStatus.PENDING,
  InvoiceStatus.DISPUTED,
  InvoiceStatus.RETURNED
];

export const INVOICE_STATUSES_AWAITING_CLIENT: InvoiceStatus[] = [
  InvoiceStatus.OPENED,
  InvoiceStatus.OVERDUE
];

export const INVOICE_STATUSES_OUTSTANDING: InvoiceStatus[] = [
  ...INVOICE_STATUSES_ACTION_REQUIRED,
  ...INVOICE_STATUSES_AWAITING_CLIENT
];

export const INVOICE_STATUSES_IN_PROGRESS: InvoiceStatus[] = [
  InvoiceStatus.PAYMENT_IN_TRANSIT
];

export const INVOICE_STATUSES_DEPOSITED: InvoiceStatus[] = [
  InvoiceStatus.PAID,
  InvoiceStatus.PARTIALLY_PAID,
  InvoiceStatus.PAID_OFF_PLATFORM
];

export const INVOICE_STATUSES_REFUNDED: InvoiceStatus[] = [
  InvoiceStatus.REFUNDED,
  InvoiceStatus.PARTIALLY_REFUNDED
];
